export const reportsEn: Record<string, string> = {
  'reports.title': 'Reports',
  'reports.subtitle': 'Business intelligence & analytics',
  'reports.overview': 'Overview',
  'reports.revenue': 'Revenue',
  'reports.cashflow': 'Cashflow',
  'reports.operational': 'Operational',
  'reports.this_month': 'This Month',
  'reports.last_month': 'Last Month',
  'reports.last_3_months': 'Last 3 Months',
  'reports.ytd': 'Year to Date',
  'reports.revenue_label': 'Revenue',
  'reports.growth': 'Growth',
  'reports.orders_created': 'Orders Created',
  'reports.outstanding': 'Outstanding',
  'reports.overdue_invoices': 'Overdue Invoices',
  'reports.revenue_trend': 'Revenue Trend',
  'reports.by_payment_method': 'By Payment Method',
  'reports.upcoming_deliveries': 'Upcoming Deliveries (14 days)',
  'reports.overdue_invoices_table': 'Overdue Invoices',
  'reports.revenue_period': 'Revenue (Period)',
  'reports.revenue_ytd': 'Revenue YTD',
  'reports.avg_per_order': 'Avg per Order',
  'reports.paying_customers': 'Paying Customers',
  'reports.revenue_breakdown': 'Revenue Breakdown',
  'reports.by_month': 'By Month',
  'reports.by_brand': 'By Brand',
  'reports.by_category': 'By Category',
  'reports.by_payment': 'By Payment',
  'reports.collected_this_month': 'Collected This Month',
  'reports.collected_last_month': 'Collected Last Month',
  'reports.outstanding_total': 'Outstanding Total',
  'reports.overdue_total': 'Overdue Total',
  'reports.avg_days_to_pay': 'Avg Days to Pay',
  'reports.invoice_aging': 'Invoice Aging',
  'reports.payment_timeline': 'Payment Timeline',
  'reports.order_pipeline': 'Order Pipeline',
  'reports.delivery_forecast': 'Delivery Forecast (Projected)',
  'reports.tailoring_insight': 'Tailoring Insight',
  'reports.avg_tailoring_cost': 'Avg Tailoring Cost',
  'reports.cost_pct_of_order': 'Cost % of Order',
  'reports.orders_above_threshold': 'Orders Above Threshold',
  'reports.total_orders': 'Total Orders',
  'reports.order': 'Order',
  'reports.customer': 'Customer',
  'reports.date': 'Date',
  'reports.unpaid': 'Unpaid',
  'reports.invoice': 'Invoice',
  'reports.days': 'Days',
  'reports.due': 'Due',
  'reports.paid': 'Paid',
  'reports.name': 'Name',
  'reports.pct_total': '% Total',
  'reports.units': 'Units',
  'reports.avg_value': 'Avg Value',
  'reports.bucket': 'Bucket',
  'reports.count': 'Count',
  'reports.amount': 'Amount',
  'reports.monthly': 'Monthly',
  'reports.weekly': 'Weekly',
  'reports.this_week': 'This Week',
  'reports.last_week': 'Last Week',
  'reports.no_data_title': 'No data yet',
  'reports.no_data_subtitle': 'Orders and payments will appear here once recorded.',
  'reports.error_title': 'Something went wrong loading this section.',
  'reports.retry': 'Retry',
  'reports.view_all': 'View all',
  'reports.export_csv': 'Export CSV',
  'reports.export_pdf': 'Export PDF',
  'reports.coming_soon': 'Coming soon',
  'reports.sort_asc': 'Sort ascending',
  'reports.sort_desc': 'Sort descending',
  'reports.all_deliveries': 'All Upcoming Deliveries',
  'reports.all_overdue': 'All Overdue Invoices',
  'reports.back_to_overview': 'Back to Overview',
  'reports.download': 'Download',
  'reports.exported': 'Exported successfully',
  'reports.compare_previous': 'Compare to previous period',
  'reports.vs_previous': 'vs previous period',
  'reports.revenue_recognition_note': 'Revenue is recognized when payments are received (successful payments only).',
  'reports.projected': 'Projected',
  'reports.not_recognized': 'Not yet recognized',
  'reports.cash_received_this_month': 'Cash Received (This Month)',
  'reports.cash_received_last_month': 'Cash Received (Last Month)',
  'reports.outstanding_tooltip': 'Total unpaid balance across all orders, not filtered by the selected period',
  'reports.custom_range': 'Custom Range',
  'reports.custom_range_hint': 'Available with live data',
  'reports.insufficient_history': 'Not enough prior data for comparison',
  'reports.daily': 'Daily',
  'reports.custom_range_start': 'Start date',
  'reports.custom_range_end': 'End date',
  'reports.custom_range_apply': 'Apply',
  'reports.customers': 'Customers',
  'reports.new_customers': 'New Customers',
  'reports.repeat_customers': 'Repeat Customers',
  'reports.avg_revenue_per_customer': 'Avg Revenue / Customer',
  'reports.top_customers': 'Top Customers by Revenue',
  'reports.last_order': 'Last Order',
  'reports.orders_count': 'Orders',
  'reports.next_14_days': '14 days',
  'reports.next_1_month': '1 month',
  'reports.next_3_months': '3 months',
  'reports.upcoming_deliveries_title': 'Upcoming Deliveries',
  'reports.revenue_ytd_tooltip': 'Total revenue from Jan 1, {year} to today',
  'reports.orders_column': 'Orders',
  'reports.items_sold': 'Items Sold',
  'reports.paying_customers_tooltip': 'Unique customers with at least one successful payment in the selected period',
  'reports.forecast': 'Forecast',
  'reports.scheduled_revenue': 'Scheduled Revenue',
  'reports.historical_baseline': 'Historical Baseline',
  'reports.predicted_total': 'Predicted Total',
  'reports.coverage_pct': 'Coverage %',
  'reports.scheduled': 'Scheduled',
  'reports.historical': 'Historical',
  'reports.forecast_subtitle': 'Based on payment request due dates and same-period revenue from last year',
  'reports.scheduled_tooltip': 'Unpaid payment requests with due dates in this period',
  'reports.historical_tooltip': 'Actual payments received in the same months one year ago',
  'reports.at_risk_orders': 'At-Risk Orders',
  'reports.no_at_risk': 'All orders on track — no issues detected',
  'reports.tailoring_queue': 'Tailoring Queue',
  'reports.pending_tasks': 'Pending',
  'reports.in_progress_tasks': 'In Progress',
  'reports.overdue_tasks': 'Overdue',
  'reports.avg_days_in_status': 'Avg Days',
  'reports.delivery_readiness': 'Delivery Readiness by Month',
  'reports.ready': 'Ready',
  'reports.still_in_progress': 'still in progress',
  'reports.status': 'Status',
  'reports.demo_banner_title': 'Demo Data',
  'reports.demo_banner_description': 'You are viewing sample data for demonstration purposes. This is not your real business data.',
};
